/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddressDto {
  /** @example "b" */
  addition?: string;
  /**
   * @minLength 1
   * @example "Hamburg"
   */
  city: string;
  /**
   * Country code in ISO-3166-1 ALPHA-2 format
   * @minLength 1
   * @example "DE"
   */
  country: string;
  /** @example "1" */
  houseNumber?: string;
  /**
   * @minLength 1
   * @example "22089"
   */
  postCode: string;
  /**
   * @minLength 1
   * @example "Wartenau"
   */
  street: string;
}

export interface AuditInfoDto {
  /**
   * @minLength 1
   * @example "system"
   */
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  /**
   * @minLength 1
   * @example "system"
   */
  lastModifiedBy: string;
  /** @format date-time */
  lastModifiedDate: string;
  /**
   * @format int64
   * @example 1
   */
  version: number;
}

export interface CreatePicklistDto {
  /**
   * @deprecated
   * @format uuid
   */
  labelPrinterId?: string;
  /** @format uuid */
  printerId: string;
  process: ShipmentProcessTypeDto;
  /** @uniqueItems true */
  shipmentTypes?: ShipmentTypeDto[];
}

export interface CreateShipmentLabelDto {
  /** @format uuid */
  labelPrinterId: string;
  /**
   * @minLength 1
   * @minItems 1
   */
  packageId: string[];
}

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
  slaEndOfWorkday?: string;
}

export enum DocumentTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface OriginReferenceDto {
  origin: OriginTypeDto;
  reference: string;
}

export enum OriginTypeDto {
  STS = "STS",
  REM_API = "REM_API",
  SCB_API = "SCB_API",
  ON_API = "ON_API",
}

export interface PicklistDetailDto {
  audit: AuditInfoDto;
  items: ShipmentPackageItemDto[];
}

export enum PicklistFilterLastScanStatus {
  COMPLETE = "COMPLETE",
  INCOMPLETE = "INCOMPLETE",
}

export interface PicklistListDto {
  items: PicklistListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface PicklistListItemDto {
  /** @format uuid */
  id: string;
  /** @format int32 */
  itemCount: number;
}

export interface PicklistOverviewListDto {
  items: PicklistOverviewListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface PicklistOverviewListItemDto {
  audit: AuditInfoDto;
  /** @format uuid */
  id: string;
  /** @format int64 */
  itemsToScan: number;
}

export interface PrintDto {
  /** @format uuid */
  printerId: string;
}

export interface PrinterProjectionDto {
  displayName: string;
  name: string;
  /** @format uuid */
  printerId: string;
}

export enum PrinterType {
  DOCUMENT = "DOCUMENT",
  ZEBRA = "ZEBRA",
  VLOG = "VLOG",
}

export interface ReceiverDto {
  address: AddressDto;
  /** @minLength 1 */
  line1: string;
  line2?: string;
  mail?: string;
  phone?: string;
}

export interface ResourceReferenceDto {
  /** @format uuid */
  id: string;
}

export interface ResourceReferencesDto {
  ids: string[];
}

export interface ShipmentListDto {
  items: ShipmentListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface ShipmentListItemDto {
  auditInfo: AuditInfoDto;
  cancelled: boolean;
  customerDisplay: string;
  documentType: DocumentTypeDto;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastScan?: string;
  lost: boolean;
  /** @format uuid */
  packageId: string;
  /** @format uuid */
  picklistId: string;
  process: ShipmentProcessTypeDto;
  ready: boolean;
  receiver: ReceiverDto;
  shipmentType: ShipmentTypeDto;
  status: ShipmentPackageStatusDto;
  /** Fahrgestellnummer */
  vin: string;
}

/** Columns available for sorting */
export enum ShipmentListSortByDto {
  LAST_MODIFIED = "LAST_MODIFIED",
  VIN = "VIN",
  RECEIVER = "RECEIVER",
  SHIPMENT_TYPE = "SHIPMENT_TYPE",
  PROCESS_TYPE = "PROCESS_TYPE",
}

export interface ShipmentOrderDto {
  billable: boolean;
  /** @deprecated */
  carrier?: ShippingCarrierTypeDto;
  /** @format uuid */
  customerId: string;
  /**
   * @maxItems 2147483647
   * @minItems 1
   * @uniqueItems true
   */
  documentType?: DocumentTypeDto[];
  /** Referenz zur Übertragung an das Versandlabel */
  labelReference?: string;
  process: ShipmentProcessTypeDto;
  receiver: ReceiverDto;
  shipmentType: ShipmentTypeDto;
  /**
   * Fahrgestellnummer
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface ShipmentPackageDataDto {
  billable: boolean;
  cancelled: boolean;
  /** @deprecated */
  carrier?: ShippingCarrierTypeDto;
  /** @format int32 */
  compartment?: number;
  /** @format uuid */
  customerId: string;
  packageItems: ShipmentPackageItemDto[];
  processType: ShipmentProcessTypeDto;
  receiver: ReceiverDto;
  /** @uniqueItems true */
  references?: OriginReferenceDto[];
  shipmentType: ShipmentTypeDto;
  status: ShipmentPackageStatusDto;
  trackingNumber?: string;
  /** @uniqueItems true */
  vins: string[];
}

export interface ShipmentPackageDto {
  audit: AuditInfoDto;
  /** @deprecated */
  carrier?: ShippingCarrierTypeDto;
  /** @format int32 */
  compartment: number;
  customerDisplay: string;
  /** @format uuid */
  customerId: string;
  items: ShipmentPackageItemDto[];
  processType: ShipmentProcessTypeDto;
  receiver: ReceiverDto;
  /** @uniqueItems true */
  references?: OriginReferenceDto[];
  shipmentType: ShipmentTypeDto;
  status: ShipmentPackageStatusDto;
  trackingNumber?: string;
  /** @uniqueItems true */
  vins: string[];
}

export interface ShipmentPackageFinishCustomerDto {
  /** @format uuid */
  customerId: string;
  /** @format uuid */
  documentPrinterId: string;
  /** @format uuid */
  labelPrinterId?: string;
  processType: ShipmentProcessTypeDto;
}

export interface ShipmentPackageFinishDto {
  /** @format uuid */
  documentPrinterId: string;
  /** @format uuid */
  labelPrinterId?: string;
}

export interface ShipmentPackageItemDto {
  cancelled: boolean;
  /** @format date-time */
  createdDate: string;
  /** @format uuid */
  dataElementId?: string;
  documentId?: string;
  documentType: DocumentTypeDto;
  hasCoverLetter: boolean;
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastScan?: string;
  lost: boolean;
  /** @format uuid */
  picklistId?: string;
  ready: boolean;
  storageLocation?: string;
  vin: string;
}

export interface ShipmentPackageListDto {
  items: ShipmentPackageListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface ShipmentPackageListItemDto {
  audit: AuditInfoDto;
  /** @format int32 */
  compartment?: number;
  customerDisplay: string;
  /** @format uuid */
  id: string;
  process: ShipmentProcessTypeDto;
  receiver: ReceiverDto;
  shipmentType: ShipmentTypeDto;
  status: ShipmentPackageStatusDto;
  /** Fahrgestellnummern */
  vins: string[];
}

/** Columns available for sorting */
export enum ShipmentPackageListSortByDto {
  LAST_MODIFIED = "LAST_MODIFIED",
}

export interface ShipmentPackageSaveEventDto {
  audit: AuditInfoDto;
  data: ShipmentPackageDataDto;
  /** @format uuid */
  id: string;
}

export enum ShipmentPackageStatusDto {
  ACTIVE = "ACTIVE",
  CLOSING = "CLOSING",
  CLOSED = "CLOSED",
}

export interface ShipmentPackageUpdateReceiverDto {
  receiver: ReceiverDto;
  /**
   * @format int64
   * @example 1
   */
  version: number;
}

export interface ShipmentPackageUpdateShipmentTypeDto {
  shipmentType: ShipmentTypeDto;
}

export enum ShipmentProcessTypeDto {
  REGULAR = "REGULAR",
  INTERNAL = "INTERNAL",
  STORAGE_TRANSFER = "STORAGE_TRANSFER",
  STORAGE_TRANSFER_SCA = "STORAGE_TRANSFER_SCA",
  STORAGE_TRANSFER_SCA_FINISH = "STORAGE_TRANSFER_SCA_FINISH",
  MVR_ON = "MVR_ON",
  MVR = "MVR",
}

export enum ShipmentTypeDto {
  MORNING = "MORNING",
  LATE_MORNING = "LATE_MORNING",
  NOON = "NOON",
  TRACKED = "TRACKED",
  POST = "POST",
}

export enum ShippingCarrierTypeDto {
  POST = "POST",
  DHL = "DHL",
  DPI = "DPI",
  UPS = "UPS",
  GO = "GO",
  TNT = "TNT",
  GLS = "GLS",
  DPD = "DPD",
  INTERNAL = "INTERNAL",
}

export interface ShippingClientDataDto {
  carrier: ShippingCarrierTypeDto;
  /**
   * @minLength 1
   * @pattern ^([0-9]){3}$
   */
  clientNumber: string;
  /** @minLength 1 */
  label: string;
}

export interface ShippingClientDto {
  audit: AuditInfoDto;
  data: ShippingClientDataDto;
}

export interface ShippingClientListDto {
  items: ShippingClientListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface ShippingClientListItemDto {
  carrier: ShippingCarrierTypeDto;
  clientNumber: string;
  /** @format uuid */
  id: string;
  label: string;
}

export interface ShippingConfigurationDataDto {
  items: Record<string, Record<string, Record<string, string>>>;
}

export enum ShippingDestinationTypeDto {
  DOMESTIC = "DOMESTIC",
  EU = "EU",
  NON_EU = "NON_EU",
}

/** The SortType */
export enum SortTypeDto {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Fulfilment Management Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Fms<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Picklist
     * @name ListPicklists
     * @request GET:/api/v1/picklist
     * @secure
     */
    listPicklists: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        lastScanStatus?: PicklistFilterLastScanStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<PicklistOverviewListDto, any>({
        path: `/api/v1/picklist`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picklist
     * @name GetPicklistDetail
     * @request GET:/api/v1/picklist/{id}
     * @secure
     */
    getPicklistDetail: (id: string, params: RequestParams = {}) =>
      this.request<PicklistDetailDto, any>({
        path: `/api/v1/picklist/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picklist
     * @name PrintPicklist
     * @request POST:/api/v1/picklist/{id}
     * @secure
     */
    printPicklist: (id: string, data: PrintDto, params: RequestParams = {}) =>
      this.request<PicklistDetailDto, any>({
        path: `/api/v1/picklist/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Picklist
     * @name LastScan
     * @request POST:/api/v1/picklist/{picklistId}/item/{itemId}/last-scan
     * @secure
     */
    lastScan: (picklistId: string, itemId: string, params: RequestParams = {}) =>
      this.request<PicklistDetailDto, any>({
        path: `/api/v1/picklist/${picklistId}/item/${itemId}/last-scan`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printer Projection
     * @name FindPrinters
     * @summary Find first 50 printers
     * @request GET:/api/v1/projection/printer/document
     * @secure
     */
    findPrinters: (
      query?: {
        query?: string;
        printer?: PrinterType;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrinterProjectionDto[], any>({
        path: `/api/v1/projection/printer/document`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment
     * @name ListShipment
     * @request GET:/api/v1/shipment
     * @secure
     */
    listShipment: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        /** Columns available for sorting */
        sortBy?: ShipmentListSortByDto;
        /** The SortType */
        sortType?: SortTypeDto;
        q?: string;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
        /** @uniqueItems true */
        documentType?: DocumentTypeDto[];
        /** @uniqueItems true */
        shipmentType?: ShipmentTypeDto[];
        /** @uniqueItems true */
        process?: ShipmentProcessTypeDto[];
        /** @uniqueItems true */
        status?: ShipmentPackageStatusDto[];
        lost?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentListDto, any>({
        path: `/api/v1/shipment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment
     * @name CreateShipment
     * @summary Create shipments for given documents of VIN
     * @request POST:/api/v1/shipment
     * @secure
     */
    createShipment: (
      data: {
        /**
         * PDF document
         * @format binary
         */
        attachment?: File;
        shipment: ShipmentOrderDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceReferenceDto, any>({
        path: `/api/v1/shipment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name ListPackages
     * @request GET:/api/v1/shipment/packages
     * @secure
     */
    listPackages: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        /** Columns available for sorting */
        sortBy?: ShipmentPackageListSortByDto;
        /** The SortType */
        sortType?: SortTypeDto;
        q?: string;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
        /** @uniqueItems true */
        shipmentType?: ShipmentTypeDto[];
        /** @uniqueItems true */
        process?: ShipmentProcessTypeDto[];
        /** @uniqueItems true */
        status?: ShipmentPackageStatusDto[];
        /** @format int32 */
        compartment?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShipmentPackageListDto, any>({
        path: `/api/v1/shipment/packages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Finish all packages of customer ready to be finished
     *
     * @tags Shipment Package
     * @name FinishPackages
     * @request POST:/api/v1/shipment/packages/finish
     * @secure
     */
    finishPackages: (data: ShipmentPackageFinishCustomerDto, params: RequestParams = {}) =>
      this.request<ResourceReferencesDto, any>({
        path: `/api/v1/shipment/packages/finish`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name CreateShipmentPackageLabel
     * @request POST:/api/v1/shipment/packages/label
     * @secure
     */
    createShipmentPackageLabel: (data: CreateShipmentLabelDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/shipment/packages/label`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Creates picklists for all active packages
     *
     * @tags Shipment Package Picklist
     * @name CreatePicklists
     * @request POST:/api/v1/shipment/packages/picklist
     * @secure
     */
    createPicklists: (data: CreatePicklistDto, params: RequestParams = {}) =>
      this.request<ResourceReferencesDto, any>({
        path: `/api/v1/shipment/packages/picklist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name ValidateShipmentPackageReceiverUpdateDto
     * @summary Validates a shipmentPackageReceiverUpdateDto
     * @request POST:/api/v1/shipment/packages/receiver/validation
     * @secure
     */
    validateShipmentPackageReceiverUpdateDto: (data: ShipmentPackageUpdateReceiverDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/shipment/packages/receiver/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name GetPackageDetail
     * @request GET:/api/v1/shipment/packages/{id}
     * @secure
     */
    getPackageDetail: (id: string, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name PrintCoverLetterForVin
     * @summary Print cover letter for vehicle in package
     * @request POST:/api/v1/shipment/packages/{id}/coverletter/{vin}
     * @secure
     */
    printCoverLetterForVin: (id: string, vin: string, data: PrintDto, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${id}/coverletter/${vin}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package Picklist
     * @name GetPicklists
     * @request GET:/api/v1/shipment/packages/{id}/picklist
     * @secure
     */
    getPicklists: (id: string, params: RequestParams = {}) =>
      this.request<PicklistListDto, any>({
        path: `/api/v1/shipment/packages/${id}/picklist`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package Picklist
     * @name CreatePicklist
     * @request POST:/api/v1/shipment/packages/{id}/picklist
     * @secure
     */
    createPicklist: (id: string, data: CreatePicklistDto, params: RequestParams = {}) =>
      this.request<ResourceReferenceDto, any>({
        path: `/api/v1/shipment/packages/${id}/picklist`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name FinishPackage
     * @request POST:/api/v1/shipment/packages/{packageId}/finish
     * @secure
     */
    finishPackage: (packageId: string, data: ShipmentPackageFinishDto, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${packageId}/finish`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name ItemCancel
     * @request POST:/api/v1/shipment/packages/{packageId}/item/{itemId}/cancel
     * @secure
     */
    itemCancel: (packageId: string, itemId: string, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${packageId}/item/${itemId}/cancel`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name ItemLost
     * @request POST:/api/v1/shipment/packages/{packageId}/item/{itemId}/not-locatable
     * @secure
     */
    itemLost: (packageId: string, itemId: string, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${packageId}/item/${itemId}/not-locatable`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name UpdateReceiver
     * @request POST:/api/v1/shipment/packages/{packageId}/receiver
     * @secure
     */
    updateReceiver: (packageId: string, data: ShipmentPackageUpdateReceiverDto, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${packageId}/receiver`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment Package
     * @name UpdateShipmentType
     * @request POST:/api/v1/shipment/packages/{packageId}/shipmentType
     * @secure
     */
    updateShipmentType: (packageId: string, data: ShipmentPackageUpdateShipmentTypeDto, params: RequestParams = {}) =>
      this.request<ShipmentPackageDto, any>({
        path: `/api/v1/shipment/packages/${packageId}/shipmentType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipment
     * @name ValidateShipment
     * @summary Validates a shipment
     * @request POST:/api/v1/shipment/validation
     * @secure
     */
    validateShipment: (data: ShipmentOrderDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/shipment/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Client
     * @name ListShippingClients
     * @request GET:/api/v1/shipping-client
     * @secure
     */
    listShippingClients: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShippingClientListDto, any>({
        path: `/api/v1/shipping-client`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Client
     * @name CreateShippingClient
     * @request POST:/api/v1/shipping-client
     * @secure
     */
    createShippingClient: (data: ShippingClientDataDto, params: RequestParams = {}) =>
      this.request<ResourceReferenceDto, any>({
        path: `/api/v1/shipping-client`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Client
     * @name ValidateShippingClient
     * @summary Validates a shipping client
     * @request POST:/api/v1/shipping-client/validation
     * @secure
     */
    validateShippingClient: (data: ShippingClientDataDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/shipping-client/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Client
     * @name GetShippingClient
     * @request GET:/api/v1/shipping-client/{id}
     * @secure
     */
    getShippingClient: (id: string, params: RequestParams = {}) =>
      this.request<ShippingClientDto, any>({
        path: `/api/v1/shipping-client/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Client
     * @name UpdateShippingClient
     * @request PUT:/api/v1/shipping-client/{id}
     * @secure
     */
    updateShippingClient: (id: string, data: ShippingClientDto, params: RequestParams = {}) =>
      this.request<ShippingClientDto, any>({
        path: `/api/v1/shipping-client/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Configuration
     * @name GetShippingConfiguration
     * @request GET:/api/v1/shipping/configuration
     * @secure
     */
    getShippingConfiguration: (params: RequestParams = {}) =>
      this.request<ShippingConfigurationDataDto, any>({
        path: `/api/v1/shipping/configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Configuration
     * @name SaveShippingConfiguration
     * @request POST:/api/v1/shipping/configuration
     * @secure
     */
    saveShippingConfiguration: (data: ShippingConfigurationDataDto, params: RequestParams = {}) =>
      this.request<ShippingConfigurationDataDto, any>({
        path: `/api/v1/shipping/configuration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shipping Configuration
     * @name ValidateShippingConfiguration
     * @summary Validates shipping configuration
     * @request POST:/api/v1/shipping/configuration/validation
     * @secure
     */
    validateShippingConfiguration: (data: ShippingConfigurationDataDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/shipping/configuration/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
